import React from "react";
import { FiFileText, FiRefreshCw, FiSearch } from "react-icons/fi";
import { formatTimestamp } from "../adminUtils";

const AdminLogsTab = ({
  isActive,
  logSearch,
  setLogSearch,
  logDateFrom,
  setLogDateFrom,
  logDateTo,
  setLogDateTo,
  logCategoryOptions,
  logCategoryFilter,
  toggleLogCategory,
  handleExportLogs,
  handleLogResetFilters,
  filteredLogEntries,
  pagedLogEntries,
  logPage,
  logPageCount,
  setLogPage,
  focusedAuditTarget,
  handleOpenLogDrawer,
  auditLoading,
  auditError,
}) => (
  <div
    className={`admin-tab ${isActive ? "admin-tab--active" : ""}`.trim()}
  >
    <section className="admin-section admin-logs admin-animate admin-animate--delay-6">
      <header className="admin-logs__header">
        <div>
          <p className="admin-section__eyebrow">Logs</p>
          <h2>Audit timeline</h2>
        </div>
        <span className="admin-logs__count">
          {filteredLogEntries.length} events
        </span>
      </header>
      <div className="admin-logs__filterbar">
        <div className="admin-logs__search">
          <FiSearch aria-hidden="true" />
          <input
            type="search"
            value={logSearch}
            onChange={(event) => setLogSearch(event.target.value)}
            placeholder="Search booking ID, email, partner, refund ID"
          />
        </div>
        <div className="admin-logs__filter admin-logs__filter--range">
          <div className="admin-logs__range-field">
            <input
              type="datetime-local"
              className="admin-input admin-input--compact"
              value={logDateFrom}
              onChange={(event) => setLogDateFrom(event.target.value)}
            />
          </div>
          <span className="admin-logs__range-divider">-&gt;</span>
          <div className="admin-logs__range-field">
            <input
              type="datetime-local"
              className="admin-input admin-input--compact"
              value={logDateTo}
              onChange={(event) => setLogDateTo(event.target.value)}
            />
          </div>        </div>
        <div className="admin-logs__filter admin-logs__filter--chips">
          <label className="admin-form__label">Category</label>
          <div className="admin-logs__chips">
            {logCategoryOptions.map((category) => {
              const Icon = category.icon;
              const isActive = logCategoryFilter.includes(category.id);
              return (
                <button
                  key={category.id}
                  type="button"
                  className={`admin-logs__chip ${isActive ? "admin-logs__chip--active" : ""
                    }`.trim()}
                  onClick={() => toggleLogCategory(category.id)}
                >
                  <Icon aria-hidden="true" />
                  {category.label}
                </button>
              );
            })}
          </div>
        </div>
        <div className="admin-logs__filter admin-logs__filter--export">
          <label className="admin-form__label">Export</label>
          <div className="admin-logs__export">
            <button
              type="button"
              className="admin-button admin-button--outline"
              onClick={() => handleExportLogs("csv")}
            >
              CSV
            </button>
            <button
              type="button"
              className="admin-button admin-button--outline"
              onClick={() => handleExportLogs("json")}
            >
              JSON
            </button>
            <button
              type="button"
              className="admin-icon-button"
              onClick={handleLogResetFilters}
              aria-label="Reset log filters"
            >
              <FiRefreshCw aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <div className="admin-logs__timeline">
        {auditLoading ? (
          <p className="admin-empty">Loading logs...</p>
        ) : auditError ? (
          <p className="admin-empty">{auditError}</p>
        ) : filteredLogEntries.length === 0 ? (
          <p className="admin-empty">No logs match the current filters.</p>
        ) : (
          (pagedLogEntries || filteredLogEntries).map((entry) => {
            const Icon = entry.categoryIcon || FiFileText;
            return (
              <button
                key={entry.id}
                type="button"
                className={`admin-logs__row ${focusedAuditTarget && entry.target === focusedAuditTarget
                    ? "admin-logs__row--focused"
                    : ""
                  }`.trim()}
                onClick={() => handleOpenLogDrawer(entry)}
              >
                <span
                  className={`admin-logs__strip admin-logs__strip--${entry.severityTone}`}
                />
                <span className="admin-logs__icon">
                  <Icon aria-hidden="true" />
                </span>
                <div className="admin-logs__content">
                  <p className="admin-logs__summary">{entry.summary}</p>
                  <p className="admin-logs__meta">
                    <span>{entry.action}</span>
                    <span>·</span>
                    <span>{entry.target}</span>
                  </p>
                </div>
                <div className="admin-logs__side">
                  <span className="admin-logs__timestamp">
                    {formatTimestamp(entry.createdUtc)}
                  </span>
                </div>
              </button>
            );
          })
        )}
      </div>
      {!auditLoading && !auditError && filteredLogEntries.length > 0 && (
        <div className="admin-money__pagination">
          <button
            type="button"
            className="admin-button admin-button--ghost"
            onClick={() => setLogPage((prev) => Math.max(1, prev - 1))}
            disabled={logPage <= 1}
            aria-label="Prev"
          >
            {"<"}
          </button>
          <span className="admin-money__page">
            Page {logPage} of {logPageCount}
          </span>
          <button
            type="button"
            className="admin-button admin-button--ghost"
            onClick={() =>
              setLogPage((prev) => Math.min(logPageCount, prev + 1))
            }
            disabled={logPage >= logPageCount}
            aria-label="Next"
          >
            {">"}
          </button>
        </div>
      )}
    </section>
  </div>

);

export default AdminLogsTab;
